import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HealthMetricsRequest, ReferralCreateRequest, ReferralCreateResponse, SubmitAnswersRequest } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class FunnelService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  submitFunnelData(data: any): Observable<any> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post<any>(`${this.baseUrl}/api/funnel/submit`, data, { headers });
  }

  getQuestions(area?: string): Observable<any[]> {
    const params = area ? new HttpParams().set('area', area) : undefined;
    return this.http.get<any[]>(`${this.baseUrl}/api/v1/question`, { params });
  }

  createReferral(referral: ReferralCreateRequest): Observable<ReferralCreateResponse> {
    return this.http.post<ReferralCreateResponse>(`${this.baseUrl}/api/v1/referrals`, referral);
  }

  updateReferral(referralId: string, referral: Partial<ReferralCreateRequest>): Observable<ReferralCreateResponse> {
    return this.http.patch<ReferralCreateResponse>(`${this.baseUrl}/api/v1/referrals/${referralId}`, referral);
  }

  submitQuestionAnswers(payload: SubmitAnswersRequest): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/v1/question/answers`, payload);
  }

  submitHealthMetrics(payload: HealthMetricsRequest): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/v1/health-metrics`, payload);
  }

  sendVerificationCode(email: string, type: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/v1/verification/send-code`, { email, type });
  }

  verifyCode(email: string, code: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/v1/verification/verify-code`, { email, code });
  }

}
